import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../../../assets/css/gcstudent/studentauthentication/StudentAuthPages.css";
import axios from "axios";
import AppContext from "../../../context/AppContext";

const BookIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
    <path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const StarIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" fill="#fff" />
  </svg>
);

const EyeIcon = ({ show }) =>
  show ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );

const StudentLoginPage = () => {
  const navigate = useNavigate();
  const { baseUrl, validateStudentLoginForm, setLoggedInUser, setAuthToken, setUserType, loggedInUser, userType, authLoading } =
    useContext(AppContext);

  const [cardIn, setCardIn] = useState(false);
  const [roll_no, setRollNo] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setTimeout(() => setCardIn(true), 60);
  }, []);

 useEffect(() => {
  if (authLoading) return;
  if (loggedInUser && userType === "student") {

    if (loggedInUser.aiConversation) {
      localStorage.setItem(
        "aiConversationId",
        loggedInUser.aiConversation.id
      );
    }

    redirectAfterLogin();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [loggedInUser, userType, authLoading]);

  const clearError = (field) => setErrors((prev) => ({ ...prev, [field]: "" }));

  const redirectAfterLogin = () => {
  const pending = localStorage.getItem("pendingReservation");
  if (pending) {
    navigate("/confirm-reservation");
  } else {
    navigate("/student/dashboard");
  }
};

  const studentLogin = (e) => {
    e.preventDefault();
    setApiError("");
    const validationErrors = validateStudentLoginForm({ roll_no, password });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    localStorage.removeItem("authToken");
    setLoading(true);

    const formData = new FormData();
    formData.append("roll_no", roll_no);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/student/auth/studentLogin`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => {
        setLoading(false);
        if (res.data.success === true) {
          setAuthToken(res.data.token);
          setUserType("student");
          setLoggedInUser(res.data.student);
          
          redirectAfterLogin();
        } else {
          setApiError(res.data.message || "Login failed. Please try again.");
        }
      })
      .catch((error) => {
        setLoading(false);
        const msg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          "Something went wrong. Please try again.";
        setApiError(msg);
      });
  };

  return (
    <div className="gcStudent-auth-bg">
      <div className={`gcStudent-auth-shell ${cardIn ? "gcStudent-auth-shell--in" : ""}`}>

        <div className="gcStudent-auth-side">
          <div className="gcStudent-auth-brand">
            <BookIcon />
            <span>GGCW Library</span>
          </div>

          <div className="gcStudent-auth-side-main">
            <div className="gcStudent-auth-badge">
              <StarIcon />
              <span>For Students</span>
            </div>

            <h1 className="gcStudent-auth-side-title">New Here?</h1>
            <p className="gcStudent-auth-side-sub">
              New to GGCW Library? Create your student account in seconds and unlock thousands of books.
            </p>
          </div>

          <div className="gcStudent-auth-side-cta">
            <p>Don't have an account yet?</p>
            <button type="button" onClick={() => navigate("/student/register")}>
              Register here →
            </button>
          </div>
        </div>

        <div className="gcStudent-auth-form-side">
          <h2 className="gcStudent-auth-title">Student Login</h2>
          <p className="gcStudent-auth-sub">Access your dashboard, books and AI assistant.</p>

          {apiError && <div className="gcStudent-auth-error">{apiError}</div>}

          <form className="gcStudent-auth-form" noValidate>
            <input
              className={`gcStudent-auth-input ${errors.roll_no ? "gcStudent-auth-input--error" : ""}`}
              type="text"
              placeholder="Roll No (e.g. CS-21, FA-1412)"
              value={roll_no}
              onChange={(e) => { setRollNo(e.target.value); clearError("roll_no"); }}
              autoComplete="off"
            />
            {errors.roll_no && <span className="gcStudent-auth-field-error">{errors.roll_no}</span>}

            <div className="gcStudent-auth-pwd-wrap">
              <input
                className={`gcStudent-auth-input ${errors.password ? "gcStudent-auth-input--error" : ""}`}
                type={showPwd ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); clearError("password"); }}
                autoComplete="current-password"
              />
              <button type="button" className="gcStudent-auth-eye" onClick={() => setShowPwd((p) => !p)}>
                <EyeIcon show={showPwd} />
              </button>
            </div>
            {errors.password && <span className="gcStudent-auth-field-error">{errors.password}</span>}

            <div className="gcStudent-auth-forgot-row">
              <button
                type="button"
                className="gcStudent-auth-forgot"
                onClick={() => navigate("/student/forgot-password")}
              >
                Forgot password?
              </button>
            </div>

            <button
              type="button"
              className={`gcStudent-auth-btn ${loading ? "gcStudent-auth-btn--loading" : ""}`}
              disabled={loading}
              onClick={studentLogin}
            >
              {loading ? <span className="gcStudent-auth-spinner" /> : "Login"}
            </button>
          </form>

          <button className="gcStudent-auth-back" onClick={() => navigate("/")}>
            ← Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentLoginPage;